<div class="p-3">
  <div>
    <h5>{{ 'base-data' | translateWithFallback }}</h5>

    <div>
      {{ 'name' | translateWithFallback }}
      <span class="notes font-12">
        {{ (MpSvc.data$ | async)?.Name }}
      </span>
    </div>

    <div>
      {{ 'part-structure-type' | translateWithFallback }}
      <span class="notes font-12">
        {{ (MpSvc.data$ | async)?.PartStructureType }}
      </span>
    </div>

    <div>
      {{ 'part-type' | translateWithFallback }}
      <span class="notes font-12">
        {{ (MpSvc.data$ | async)?.PartType }}
      </span>
    </div>

    <div>
      {{ 'part-class-type' | translateWithFallback }}
      <span class="notes font-12">
        {{ (MpSvc.data$ | async)?.PartClassType }}
      </span>
    </div>

    <div>
      {{ 'status' | translateWithFallback }}
      <span class="notes font-12">
        {{ (MpSvc.data$ | async)?.Status }}
      </span>
    </div>

    <div>
      {{ 'errors' | translateWithFallback }}
      <span class="notes font-12">
        {{ (MpSvc.data$ | async)?.Errors }}
      </span>
    </div>
  </div>
  <div *ngIf="(MpSvc.data$ | async)?.PartStructureType == 'Physical'">
    <h5>{{ 'generic-device' | translateWithFallback }}</h5>

    <div>
      {{ 'device-model' | translateWithFallback }}
      <span class="notes font-12">
        {{ (MpSvc.data$ | async)?.DeviceModel }}
      </span>
    </div>

    <div>
      {{ 'firmware-version' | translateWithFallback }}
      <span class="notes font-12">
        {{ (MpSvc.data$ | async)?.FirmwareVersion }}
      </span>
    </div>

    <div>
      {{ 'address' | translateWithFallback }}
      <span class="notes font-12">
        {{ (MpSvc.data$ | async)?.Address }}
      </span>
    </div>
  </div>

  <div *ngIf="(MpSvc.data$ | async)?.PartType == 'Camera'">
    <h5>{{ 'camera-info' | translateWithFallback }}</h5>

    <div>
      {{ 'sensor-model' | translateWithFallback }}
      <span class="notes font-12">
        {{ (MpSvc.data$ | async)?.SensorModel }}
      </span>
    </div>

    <div>
      {{ 'slides-in-view' | translateWithFallback }}
      <span class="notes font-12">
        {{ (MpSvc.data$ | async)?.SlidesInView }}
      </span>
    </div>
  </div>
  {{(MpSvc.data$ | async)?.PartType}}
  <div *ngIf="(MpSvc.data$ | async)?.PartType == 'Slider'">
    <h5>{{ 'slider-info' | translateWithFallback }}</h5>

    <div>
      {{ 'channels' | translateWithFallback }}
      <span class="notes font-12">
        {{ (MpSvc.data$ | async)?.Channels }}
      </span>
    </div>

    <div>
      {{ 'shot-stats-from' | translateWithFallback }}
      <span class="notes font-12">
        {{ (MpSvc.data$ | async)?.ShotStatsFrom  | date:'dd/MM/yyyy hh.mm.ss'}}
      </span>
    </div>

    <div>
      {{ 'shot-stats-to' | translateWithFallback }}
      <span class="notes font-12">
        {{ (MpSvc.data$ | async)?.ShotStatsTo  | date:'dd/MM/yyyy hh.mm.ss'}}
      </span>
    </div>

    <div>
      {{ 'shot-stats-counter' | translateWithFallback }}
      <span class="notes font-12">
        {{ (MpSvc.data$ | async)?.ShotStatsCounter }}
      </span>
    </div>
  </div>

  <div *ngIf="(MpSvc.data$ | async)?.PartType == 'Slider'">
    <h5>{{ 'shot-stats' | translateWithFallback }}</h5>
    <table>
        <thead>
          <tr>
            <th>{{ 'slider' | translateWithFallback }}</th>
            <th>{{ 'valve' | translateWithFallback }}</th>
            <th>{{ 'number-shots' | translateWithFallback }}</th>
          </tr>
        </thead>
        <tbody *ngFor="let item of (MpSvc.chunks$ | async); let index = index">
          <tr>
            <td rowspan="8">{{ 'valve' | translateWithFallback }} {{index}}</td>
            <td>1</td>
            <td>{{item[0]}}</td>
          </tr>
          <tr>
            <td>2</td>
            <td>{{item[1]}}</td>
          </tr>
          <tr>
            <td>3</td>
            <td>{{item[2]}}</td>
          </tr>
          <tr>
            <td>4</td>
            <td>{{item[3]}}</td>
          </tr>
          <tr>
            <td>5</td>
            <td>{{item[4]}}</td>
          </tr>
          <tr>
            <td>6</td>
            <td>{{item[5]}}</td>
          </tr>
          <tr>
            <td>7</td>
            <td>{{item[6]}}</td>
          </tr>
          <tr>
            <td>8</td>
            <td>{{item[7]}}</td>
          </tr>
        </tbody>
      </table>
    </div>
</div>
